<template>
 
        <el-dialog
      title="我的信息"
      :visible.sync="dialogVisible"
      @close="dialogFormVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="50%"
    >

    11
    </el-dialog>

</template>
<script>
import SupplyApi from '@/api/supply.js';

export default {

  data() {
    return {
      /*是否正在加载*/
      loading: true,
      /*表单对象*/
       form: {
       
      },
          dialogVisible:false,
    };
  },
  props:['open_add','supply_id'],
  created() {
    /*获取列表*/
        this.dialogVisible = this.open_add;
    this.form.supply_id = this.supply_id;
    this.getData();

  },
  methods: {

      /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", {});
    },

    /*获取数据*/
    getData(){
      let self = this;
      self.loading = true;
      SupplyApi.getSupply({supply_id:self.form.supply_id}, true)
        .then(res => {
          let tempForm=res.data.detail;
          console.log('tempForm',tempForm);
          tempForm.supply_id = self.form.supply_id;
          self.form = tempForm;
          self.loading = false;
        })
        .catch(error => {});
    },
 

    /*提交表单*/
    onSubmit() {
      let self = this;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          let params = self.form;
          delete params.tableData;
          SupplyApi.saveSupply(params, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: '恭喜你，修改成功',
                type: 'success'
              });
              self.cancelFunc();
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },



    /*取消*/
    cancelFunc() {
      this.$router.back(-1);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/plus/supply/supply/info.vue